<template>
	<div v-if="newsItems.length" class="news-wrapper">        
        <div v-if="feedType == 'plain'">
            <news-item v-for="item in newsItems" :key="item.ID" :post="item" />
        </div>
		<transition-group 
            v-else
			name="feed-transition"
			tag="div"
            class="news-list-local"			
			enter-active-class="animated fadeInUp" 
			leave-active-class="animated fadeOut">
			<card v-for="(item, index) in newsItems" :key="index" :post="item"></card>
		</transition-group>
		<div class="p-4 py-10 text-center antialiased" v-if="moreToLoad && feedType != 'plain'">
            <button @click="loadMoreArticles" class="mg-button mg-button--accent px-6 uppercase">{{ loadMoreText }}</button>
        </div>
	</div>
    <div v-else class="mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center">
        <div v-if="totalItemsFound == null">
            Loading news...
        </div>
        <div v-else>
            Nothing found.
        </div>
    </div>
</template>

<script>
const apiBase = "/wp-json/";
const wpApi = `${apiBase}wp/v2/`;

import MLCard from "@/vue-components/ml-card";
import MLNewsItem from "@/vue-components/ml-news-item";

export default {
    props: {
        postType: {
            // the post type slug
            type: String,
            default: 'posts',
        },
        regionFilter: {
            type: Number,            
        },
        countryFilter: {
            type: Number,
        },
        loadMoreText: {
            type: String,
            default: 'Load More',
        },
        feedType: {
            type: String,
            default: 'cards',
        },     
    },
    name: "ml-card-feed",
    components: {
        card: MLCard,
        'news-item': MLNewsItem,
    },
    data() {
        return {
            newsItems: [],
            totalItemsFound: 0,
            currentPage: 1,
            perPage: 3,    
        };
    },
    computed: {        
        moreToLoad() {
            if (this.totalItemsFound === null) {
                return false;
            } else {
                return !(
                    parseInt(this.totalItemsFound) === this.newsItems.length
                );
            }
        },
        apiUrl() {
            const baseUrl = `${wpApi}${this.postType}`;
            
            let args = [
                `per_page=${this.perPage}`,
                `page=${this.currentPage}`,
            ];

            if(this.regionFilter && this.regionFilter != 0) {
                args.push(`region=${this.regionFilter}`);
            }

            if(this.countryFilter && this.countryFilter != 0) {
                args.push(`country=${this.countryFilter}`);
            }

            return `${baseUrl}?${args.join('&')}`;
        },
    },
    methods: {
        getNewsroomFeed(loadMore = false) {
            if (loadMore) {
                this.currentPage += 1;                
            }
            
            $.ajax({
                url: this.apiUrl,                    
            })
            .then(
                response => {
                    console.log(response);

                    response.forEach((post) => this.newsItems.push(post));
                    // let payload = {
                    //     posts: response.posts,
                    //     loadMore: loadMore
                    // };
                    
                    // commit("setNewsItems", payload);
                    // commit("setTotalFound", response.number_of_posts);                    
                },
                error => {
                    console.log(
                        "There was an error getting the newsroom feed"
                    );
                }
            )            
        },        
        loadMoreArticles() {
            //Check for prop, then if it's the desired post type, use the endpoint.
            this.getNewsroomFeed(true);
        }
    },
    created() {
        //Check for prop, then if it's the desired post type, use the endpoint.
        this.getNewsroomFeed();
    },
};
</script>


// WEBPACK FOOTER //
// src/js/vue-components/ml-card-feed.vue